import { GetUserContextsResponse } from "src/gen/schema/fred/fapi";
import { UserSessionResponse } from "src/gen/schema/models/user";

import { GeographicRegion, getRegionInfo } from "./regionTypes";

/**
 * Maps the current session tenant's `UserContext.geo` to a UI region, when
 * contexts are loaded (org switcher uses the same `geo` strings).
 */
export const geographicRegionFromSessionContext = (
  session: UserSessionResponse | undefined,
  userContexts: GetUserContextsResponse | undefined
): GeographicRegion | undefined => {
  if (!session?.tenantId || !userContexts?.contexts?.length) {
    return undefined;
  }
  const ctx = userContexts.contexts.find(
    (c) => c.tenantId === session.tenantId
  );
  return ctx?.geo ? getRegionInfo(ctx.geo)?.code : undefined;
};

/**
 * Best-effort fallback: derives the cell's geographic region from the page
 * hostname when the session context is unavailable (e.g. first-time signup
 * before any org exists).
 *
 * Matches patterns like `eu.dev.hyperfabric.cisco.com` or
 * `us-west-2.us.dev.hyperfabric.cisco.com`.  Returns `undefined` for
 * ambiguous hostnames such as the bare proxy `dev.hyperfabric.cisco.com`.
 */
export const geographicRegionFromHostname = ():
  | GeographicRegion
  | undefined => {
  const parts = window.location.hostname.toLowerCase().split(".");
  for (const part of parts) {
    const region = getRegionInfo(part)?.code;
    if (region) {
      return region;
    }
  }
  return undefined;
};
